module.exports = __webpack_public_path__ + "img/2012-07_bloomberg.b8330af7.png";